export default {
  en: {
    progressFixed: {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    }
  },
  fr: {
    progressFixed: {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    }
  },
  pt: {
    progressFixed: {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    }
  },
  es: {
    progressFixed: {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    }
  },
  it: {
    progressFixed: {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    }
  },
  de: {
    progressFixed: {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    }
  },
  ar: {
    progressFixed: {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    }
  }
}
